import { render, staticRenderFns } from "./customersarchive0512.vue?vue&type=template&id=9b93d9f8&scoped=true&"
import script from "./customersarchive0512.vue?vue&type=script&lang=js&"
export * from "./customersarchive0512.vue?vue&type=script&lang=js&"
import style0 from "./customersarchive0512.vue?vue&type=style&index=0&id=9b93d9f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b93d9f8",
  null
  
)

export default component.exports